import { connect } from 'react-redux';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import { getOrder, selectOrderByCode } from '../orders';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from '../../app/containers/IsSpinning';
import Page from '../../app/components/Page';
import Positions from '../components/Positions';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Status from '../components/Status';
import styles from './css/Detail.scss';
import Summary from '../components/Summary';
import SupplierOrders from '../components/SupplierOrders';
import Address from '../../addressbook/components/Address';
import Spinner from '../../app/components/Spinner';
import Helmet from "react-helmet";

@injectIntl
export class Detail extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        order: ImmutablePropTypes.map,
        match: PropTypes.object.isRequired,
        regions: ImmutablePropTypes.map,
        services: ImmutablePropTypes.map,
        spinner: PropTypes.object,
        intl: intlShape,
    }

    componentWillMount() {
        const params = {
            code: this.props.match.params.code,
        };
        this.props.dispatch(getOrder(params, { spinner: 'order.details' }));
        window.scrollTo(0, 0);
    }

    render() {
        const { order, spinner } = this.props;
        const { formatMessage } = this.props.intl;

        if (!order) {
            if (!spinner.get('order.details')) {
                return (<Page.Body>
                    <Helmet title={formatMessage({ id: 'frontend.pagetitle.order_404' })} />
                    <Page.Section depth={0}>
                        <h1>
                            <FormattedMessage
                                id='frontend.orders_detail.text.order_not_found'
                            />
                        </h1>
                    </Page.Section>
                </Page.Body>);
            }
            return (<Page.Body>
                <IsSpinning id='order.details'>
                    <Spinner />
                </IsSpinning>
            </Page.Body>);
        }

        const service = order.get('service');
        const region = order.get('region');

        if (!service || !region) {
            return (<Page.Body>
                <IsSpinning id='order.details'>
                    <Spinner />
                </IsSpinning>
            </Page.Body>);
        }

        return (
            <Page.Body>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.order' }) + order ? order.get('code') : this.props.match.params.code } />
                <IsSpinning id='orders.detail'>
                    <Spinner />
                </IsSpinning>
                <Page.Section depth={0}>
                    <h1>
                        <FormattedMessage
                            id='frontend.orders_detail.label.number'
                        /> {order ? order.get('code') : this.props.match.params.code}
                    </h1>
                </Page.Section>
                <Page.Section>
                    <Page.Content>
                        {
                            !order
                                ? (
                                    <IsSpinning id='orders.detail'>
                                        <Spinner />
                                    </IsSpinning>
                                )
                                : (

                                    <div className={styles.sections}>

                                        <div className={styles.section}>
                                            <Summary order={order} />
                                            <Positions order={order} />
                                            <Status order={order} />
                                            <SupplierOrders order={order}/>
                                            {this.renderCertificates()}
                                        </div>

                                        {this.renderAddress()}

                                    </div>
                                )
                        }
                    </Page.Content>

                </Page.Section>
            </Page.Body>
        );
    }

    renderAddress() {
        const { order } = this.props;

        if (!order.has('location')) {
            return null;
        }

        return (
            <div className={styles.section}>
                <h3>
                    <FormattedMessage id='addressbook.title.address' />
                </h3>
                <div className={styles.addressContainer}>
                    <Address className={styles.address} location={order.get('location')} />
                </div>
            </div>
        );
    }

    renderCertificates() {
        const { order } = this.props;

        if (!order) {
            return null;
        }

        const pickupPositions = order
            .get('positions')
            .filter(pos => {
                const service = pos.get('service');
                return service && service.get('alias') !== 'service.delivery'
            });

        if (pickupPositions.size == 0) {
            return null;
        }

        return (
            <div className={styles.certificates}>
                <h3>
                    <FormattedMessage id='frontend.certificate.text.info' />
                </h3>
                <ul>
                    {pickupPositions.map((pos) => {
                        return pos.get('parcels').map((parcel) => {
                            const certificate = parcel.get('certificate');
                            return <li>#{parcel.get('codePart')}: {
                                certificate
                                    ? <Link target="_blank" to={certificate.get('url')}>{certificate.get('name')}</Link>
                                    : <FormattedMessage id='frontend.certificate.text.not_available_yet' />
                            }</li>
                        });
                    })}
                </ul>
            </div>
        );
    }
}

export default withRouter(connect((state, props) => ({
    order: selectOrderByCode(state, props.match.params.code),
    spinner: state.spinner,
}))(Detail));
